import styled from "styled-components";

interface SectionFieldsContainerProps {
  isOpened: boolean;
  className?: string;
  index?: number;
}

export const FaqContainer = styled.div.attrs({})`
  max-width: 700px;
  margin: auto;
`;

export const Collapse = styled.div.attrs({})<SectionFieldsContainerProps>`
  overflow-y: hidden;
  max-height: 0;
  transform-origin: top;
  transition:
    transform 0.25s ease-in-out,
    max-height 0.25s ease-in-out;
  transform: scaleY(0);
  &.open {
    max-height: 100%;
    transform: scaleY(1);
    overflow: visible;
    z-index: ${({ index }) => 1000 + (index ?? 0)};
    position: relative;
  }
`;
